import {Stack, Typography} from "@mui/material";
import {SupplierNameAvatar} from "../SupplierNameAvatar";
import {SupplierCanonicalNameEditor} from "../SupplierCanonicalNameEditor";

type SupplierCanonicalNameCellProps = {
    entityId: number;
    canonicalName: string;
    /** `SupplierEntity.logo_url` (§2.1) — `''` for a supplier with no logo, which shows initials instead. */
    logoUrl?: string;
    /** `SupplierEntity.member_count`: shown as "n suppliers" under the name when the entity groups more than one. */
    memberCount?: number;
};

export function SupplierCanonicalNameCell({
                                              entityId,
                                              canonicalName,
                                              logoUrl,
                                              memberCount = 0,
                                          }: SupplierCanonicalNameCellProps) {
    return (
        <Stack direction="row" alignItems="center" gap={1} sx={{minWidth: 0, width: '100%'}}>
            <SupplierNameAvatar name={canonicalName} entityId={entityId} logoUrl={logoUrl}/>
            {/* Second line as in Category Profile's suppliers tab: how many raw suppliers this one sums. */}
            <Stack justifyContent="center" sx={{minWidth: 0, flex: 1, lineHeight: 1.3}}>
                <SupplierCanonicalNameEditor
                    entityId={entityId}
                    canonicalName={canonicalName}
                    typographyProps={{variant: 'body2'}}
                    inputSx={{height: '24px !important'}}
                />
                {memberCount > 1 && (
                    <Typography variant="caption" color="text.secondary" noWrap>{`${memberCount} suppliers`}</Typography>
                )}
            </Stack>
        </Stack>
    );
}
